/* eslint-enable */
/* eslint-enable */

class AnimationFourColsWithIcons {
	
	constructor(args = { sectionsContainer: document }) {
		this.sectionsContainer = args.sectionsContainer;
		this.$moduleFourColsWithIcons = this.sectionsContainer.querySelectorAll('.four-cols-with-icons');
		
		if (!this.$moduleFourColsWithIcons)
			return;
		
		this.$moduleFourColsWithIconsElements = [];
		this.$moduleFourColsWithIcons.forEach(module => {
			this.$moduleFourColsWithIconsElements.push(module.querySelectorAll('.anima'));	
		});
		
		this.init();
	}

	/* eslint-disable class-methods-use-this, no-unused-vars */
	init() {
		this.setAnimation();
	}

	setAnimation() {
		this.$moduleFourColsWithIcons.forEach((module, index) => {
			gsap.set(module, { opacity: 1});
	        gsap.set(this.$moduleFourColsWithIconsElements[index], { yPercent: 20, opacity: 0, onComplete: () => {
				this.initAnimate(index);
			} });
		});
	}

	initAnimate(index) {
		this.moduleFourColsWithIcons = gsap.timeline({
			defaults: { duration: 1.2, ease: 'power4.out' },
            scrollTrigger: {
                trigger: this.$moduleFourColsWithIcons[index],
				start: '-20% 50%'
			},
			onComplete: () => {
				gsap.set(this.$moduleFourColsWithIconsElements[index], { clearProps: true });
			}
        });
    
        this.moduleFourColsWithIcons.addLabel('step1');
        this.moduleFourColsWithIcons.to(this.$moduleFourColsWithIcons[index], { opacity: 1, duration: 1 }, 'step1');
		this.moduleFourColsWithIcons.to(this.$moduleFourColsWithIconsElements[index], { yPercent: 0, opacity: 1, stagger: 0.2 }, 'step1+=0.3');
	}
	/* eslint-enable class-methods-use-this, no-unused-vars */
}
export default AnimationFourColsWithIcons;